import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { PopOutIcon } from '../shared/PopOutIcon';
import Svg from '../shared/Svg';
import './Attendee.scss';
import PropTypes from 'prop-types';
import * as CalendarActions from '../../actions/calendar';
import officeApi from '../../../api/officeApi';
import colors from '../../utils/colors';
import { Tooltip } from '../shared/Tooltip';

export const Attendee = ({ isOrganizer, details }) => {
  const { emailAddress, displayFields, objectApiName, objectId } = details;

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const objectsAndDisplayFields = useSelector((state) => state.mail.settings?.calendarSettings?.attendeeDisplayFields);
  const currentOrganizerDisplayFields = objectsAndDisplayFields?.find((object) => object.objectApiName === objectApiName)?.displayFields.map((field) => field.apiName) || [];
  const redirectLink = `${user.salesforceInstanceUrl}/lightning/r/${objectApiName}/${objectId}/view`;
  const isComposingEvent = useSelector((state) => state.calendar.isComposingEvent);
  const outlookEventAttendees = useSelector((state) => state.calendar.eventAttendees);
  const savedAttendees = useSelector((state) => state.calendar.savedAttendees);

  const deleteAttendee = async () => {
    officeApi.removeEmailFromEvent(emailAddress, outlookEventAttendees);
    const [required, optional, organizer] = await Promise.all([...officeApi.getComposeEventAttendees()]);
    const eventAttendees = {
      organizer,
      required: Array.from(new Set([...required])),
      optional: Array.from(new Set([...optional])),
    };
    batch(() => {
      dispatch(CalendarActions.setEventAttendees(eventAttendees));
      dispatch(CalendarActions.attendeeChange());
      dispatch(CalendarActions.setSavedEventAttendees(savedAttendees.filter(({ email }) => email !== emailAddress)));
    });
  };

  return (
    <div className='attendee-card'>
      <Svg className='attendee-image' data={ isOrganizer || objectApiName === 'User' ? '/assets/people.svg' : '/assets/contact.svg' }/>
      <div className='attendee-details'>
        <Tooltip textContent={`${displayFields[currentOrganizerDisplayFields[0]]}` + (isOrganizer ? ' (Assigned to)' : '') }>
          <h2>
            {displayFields[currentOrganizerDisplayFields[0]]} { isOrganizer && <span>(Assigned to)</span> }
          </h2>
        </Tooltip>
        { currentOrganizerDisplayFields?.slice(1)?.map((currentDisplayField, index) => {
          return (
            <Tooltip key={index} textContent={`${displayFields[currentDisplayField] || ''}` }>
              <p>{displayFields[currentDisplayField]}</p>
            </Tooltip>
          );
        }) }
      </div>
      <div className='attendee-iconsContainer'>
        <PopOutIcon
          link={redirectLink}
          className='attendee-redirect'
        />
        {!isOrganizer && isComposingEvent && <Svg
          className="searchTableItem-closeIcon"
          data="../../../../assets/close.svg"
          fill={colors.searchGrey}
          tooltipContent={<span>Clear selection</span>}
          onClickAction={ deleteAttendee }
          hoverable
          hoverFill={ colors.iconHover}
        />}
      </div>
    </div>
  );
};

Attendee.propTypes = {
  isOrganizer: PropTypes.bool,
  details: PropTypes.object,
};
